import { CheckCircle2, Zap, Layers, ShieldCheck, LineChart, Users } from "lucide-react";
import useScrollReveal, { useStaggerReveal } from "@/hooks/useScrollReveal";

const ITEMS = [
  {
    icon: Zap,
    title: "Metodología Ágil garantizada",
    desc: "Sprints quincenales, demos vivas y entregas predecibles. Sin sorpresas, sin presupuestos hinchados.",
  },
  {
    icon: Layers,
    title: "Código limpio y arquitecturas escalables",
    desc: "Aplicamos estándares de la industria (SOLID, 12-Factor, CI/CD) para que tu producto crezca contigo.",
  },
  {
    icon: Users,
    title: "Diseño centrado en el usuario",
    desc: "Investigación, prototipado y pruebas de usabilidad para soluciones que la gente realmente quiere usar.",
  },
  {
    icon: ShieldCheck,
    title: "Soporte y mantenimiento continuo",
    desc: "SLAs claros, monitoreo 24/7 y planes de evolución para que tu plataforma siga siendo competitiva.",
  },
  {
    icon: LineChart,
    title: "Resultados medibles desde el sprint 1",
    desc: "Definimos KPIs de negocio antes de escribir la primera línea de código y los reportamos cada semana.",
  },
  {
    icon: CheckCircle2,
    title: "Equipo senior end-to-end",
    desc: "Ingeniería, diseño, datos y producto. Sin intermediarios, hablas directo con quien construye.",
  },
];

export default function Differentiators() {
  const headerRef = useScrollReveal();
  const gridRef = useStaggerReveal({ delayStep: 70 });
  return (
    <section
      id="diferenciadores"
      data-testid="differentiators-section"
      className="bg-[#0A0A0A] text-white relative"
    >
      <div className="px-6 md:px-12 lg:px-16 max-w-[1440px] mx-auto py-24 md:py-32">
        <div ref={headerRef} className="reveal-on-scroll grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-20">
          <div className="lg:col-span-6">
            <span className="eyebrow eyebrow-dark">[ 03 ] Por qué elegirnos</span>
            <h2 className="display-2 mt-5">
              Rigor de ingeniería.<br />
              <span className="text-[#0047FF]">Mentalidad de producto.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-[#A3A3A3] text-base md:text-lg leading-relaxed">
              No somos una fábrica de tickets. Somos un equipo que se involucra en
              tu negocio, propone, ejecuta y mide. Estos son los seis pilares que
              hacen distinta nuestra forma de trabajar.
            </p>
          </div>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {ITEMS.map((it, idx) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`diff-item-${idx}`}
                data-stagger-item
                className="bg-[#0A0A0A] p-8 md:p-10 group hover:bg-[#111] transition-colors duration-300"
              >
                <div className="flex items-center gap-3 mb-6">
                  <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#525252]">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <div className="flex-1 h-px bg-white/10" />
                  <Icon
                    size={20}
                    strokeWidth={1.5}
                    className="text-[#0047FF] group-hover:scale-110 transition-transform"
                  />
                </div>
                <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight mb-3">
                  {it.title}
                </h3>
                <p className="text-[#A3A3A3] text-[14.5px] leading-relaxed">
                  {it.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
